//////////////////////////////////////////Local
// export const baseURL = "http://localhost:5000/api/admin/";

///////////////////////////////////////// LIVE PLAYITFORWARD.FUN
export const baseURL = "https://api.playitforward.fun/api/admin/";

export const onesignal_app_id = "200d6065-cc97-4c2e-a098-2b7e02c2e3db";
export const eps = {
  verifyToken: "verifyToken",
  // // // Auth
  signIn: "auth/signin",
  updateProfile: "auth/update",
  changePassword: "auth/changePassword",
  forgotPassword: "auth/forgotPassword",
  resetPassword: "auth/resetPassword",
  logout: "auth/logout",
  updatePlayerId: "auth/updatePlayerId",
  // // // Dashboard
  dashboard: "dashboard/dashboardData",
  getPermissionsGrantedToUser:
    "dashboard/getUserPermissions?userId=${userId}&roleId=${roleId}",
  // // // Reports
  //////////////////////////////////////////////////New Calls For Old Charts in insight
  //////////Header Charts On Insight
  userStatsDataReport: "reports/userStatsDataReport",
  revenueStatsDataReport: "reports/revenueStatsDataReport",
  donationsStatsDataReport: "reports/donationsStatsDataReport",
  gamesStatsDataReport: "reports/gamesStatsDataReport",
  //////////////////////////////////////////////////For Other Charts on insight
  registeredGamesReport: "reports/registeredGamesReport",
  totalTraficReport: "reports/totalTraficReport",
  quarterlyRevenueReport: "reports/quarterlyRevenueReport",
  pastWeekDonationsReport: "reports/pastWeekDonationsReport",
  toppersReportDataReport: "reports/toppersReportDataReport",
  //////////////////////////////////////////////////Calls For Reports Page
  adsCountByGames: "reports/adsCountByGames?range=${range}&type=${type}",
  adsCountByGames12Months: "reports/adsCountByGames12Months",
  adFillReport: "reports/adFillReport",
  adViewsByUserType: "reports/adViewsByUserType",
  adViewsBySessionLength: "reports/adViewsBySessionLength",
  highValueUsers: "reports/highValueUsers?page=${page}&pageSize=${pageSize}",
  retentionRate:
    "reports/retentionRate?range=${range}&page=${page}&pageSize=${pageSize}",
  adsByGames: "reports/adsByGames?page=${page}&pageSize=${pageSize}",
  adViewsThreeHourly: "reports/adViewsThreeHourly",
  adViewsDaily: "reports/adViewsDaily",
  adViewsHourly: "reports/adViewsHourly",
  adsOnSpecialEvents:
    "reports/adsOnSpecialEvents?page=${page}&pageSize=${pageSize}",
  fillErrorsByAdType: "reports/fillErrorsByAdType",
  adsCountByPlatform: "reports/adsCountByPlatform",
  adsCountByCountries:
    "reports/adsCountByCountries?page=${page}&pageSize=${pageSize}",
  complaintsAboutAds: "reports/complaintsAboutAds",
  adsSkipRate: "reports/adsSkipRate",
  adsCountByProviders: "reports/adsCountByProviders?range=${range}",
  retentionRateByAdCapping: "reports/retentionRateByAdCapping",
  adsCountByAdsPlacement: "reports/adsCountByAdsPlacement",
  blockedAdsData: "reports/blockedAdsData?range=${range}",
  botActivities: "reports/botActivities",
  fetchableAPIs: "reports/fetchableAPIs",
  networkStats: "reports/networkStats?apiId=${apiId}&duration=${duration}",

  // // // Employees
  createEmployee: "employees/createEmployee",
  updateEmployee: "employees/updateEmployee/${id}",
  allEmployees: "employees/getAllEmployees?page=${page}&pageSize=${pageSize}",
  employeeById: "employees/getEmployeeById/${id}",
  delEmployee: "employees/deleteEmployee/${id}",
  toggleEmpStatus: "employees/toggleEmployeeState",
  allDesignations: "employees/allDesignations",
  allDepartments: "employees/allDepartments",
  allRoles: "employees/allRoles",
  uploadImage: "employees/uploadProfilePic/${id}",
  uploadDocument: "employees/uploadDocument/${id}",
  searchEmployees: "employees/searchEmployees/${query}",
  checkEmail: "employees/checkEmail",
  deleteDocument: "employees/deleteDocument/${id}",

  // // // Users
  allUserslist: "users/getAllUsers?page=${page}&pageSize=${pageSize}",
  deleteUser: "users/deleteUser/${id}",
  searchUsers:
    "users/searchUsers?query=${query}&page=${page}&pageSize=${pageSize}",
  toggleUserStatus: "users/toggleUserStatus",
  userById: "users/getUserById/${id}",
  blockUser: "users/blockUser",
  unBlockUser: "users/unBlockUser/${id}",
  // // // Cities
  allCities: "places/allCities?page=${page}&pageSize=${pageSize}",
  addCity: "places/addCity",
  updateCity: "places/updateCity",
  deleteCity: "places/deleteCity/${id}",
  citiesByProvince: "places/cities/${id}",
  searchCities:
    "places/searchCities?query=${query}&page=${page}&pageSize=${pageSize}",
  toggleCityStatus: "places/toggleCityStatus",
  restoreCity: "places/restoreCity/${id}",

  // // // Countries
  allCountries: "places/allCountries?page=${page}&pageSize=${pageSize}",
  addCountry: "places/addCountry",
  updateCountry: "places/updateCountry",
  deleteCountry: "places/deleteCountry/${id}",
  toggleCountryStatus: "places/toggleCountryStatus",
  searchCountries:
    "places/searchCountries?query=${query}&page=${page}&pageSize=${pageSize}",
  restoreCountry: "places/restoreCountry/${id}",

  // // // Provinces
  allProvinces: "places/allProvinces?page=${page}&pageSize=${pageSize}",
  addProvince: "places/addProvince",
  updateProvince: "places/updateProvince",
  provincesByCountry: "places/provinces/${id}",
  deleteProvince: "places/deleteProvince/${id}",
  searchProvinces:
    "places/searchProvinces?query=${query}&page=${page}&pageSize=${pageSize}",
  toggleProvinceStatus: "places/toggleProvinceStatus",
  restoreProvince: "places/restoreProvince/${id}",

  // // // Charitable Organizations
  addCharitableOrg: "charitableOrgs/addCharitableOrg",
  updateCharitableOrg: "charitableOrgs/updateCharitableOrg",
  getCharitableOrgs:
    "charitableOrgs/getCharitableOrgs?page=${page}&pageSize=${pageSize}",
  getCharitableOrgById: "charitableOrgs/getCharitableOrgById/${id}",
  deleteCharitableOrg: "charitableOrgs/deleteCharitableOrg/${id}",
  toggleOrgStatus: "charitableOrgs/toggleOrgStatus",
  searchCharitableOrg: "charitableOrgs/searchCharitableOrg?query=${query}",
  uploadOrgThumbnail: "charitableOrgs/uploadOrgThumbnail/${id}",
  uploadOrgImage: "charitableOrgs/uploadOrgImage/${id}",
  restoreCharitableOrg: "charitableOrgs/restoreCharitableOrg/${id}",

  // // // Ads API
  addAdsApi: "adApi/addAdsApi",
  updateAdApi: "adApi/updateAdApi",
  deleteAdApiById: "adApi/deleteAdApi/${id}",
  getAllAdsApis: "adApi/allAdsApis?page=${page}&pageSize=${pageSize}",
  toggleAdApiStatus: "adApi/toggleAdApiStatus",
  searchAdsApis:
    "adApi/searchAdsApis?query=${query}&page=${page}&pageSize=${pageSize}",
  adApiDetails: "adApi/adApiDetails",
  restoreAdApi: "adApi/restoreAdApi/${id}",
  adUnits: "adApi/adUnits/${id}",
  toggleAdUnitStatus: "adApi/toggleAdUnitStatus",
  newAdUnit: "adApi/newAdUnit",
  updateAdUnit: "adApi/updateAdUnit",
  deleteAdUnit: "adApi/deleteAdUnit?apiId=${apiId}&unitId=${unitId}",

  // // // Roles
  addNewRole: "roles/addRole",
  updateRole: "roles/updateRole",
  getRolesList: "roles/getRoles?page=${page}&pageSize=${pageSize}",
  deleteRoleById: "roles/deleteRole/${id}",
  toggleRoleStatus: "roles/toggleRoleStatus",
  searchRoles: "roles/searchRoles/?query=${query}",

  // // //FAQ's Categories
  addNewFAQsCategory: "faqs/addFAQsCategory",
  updateFAQsCategory: "faqs/updateFAQsCategory",
  getFAQsCategories: "faqs/getFAQsCategories",
  deleteFAQsCategoriesById: "faqs/deleteFAQsCategories/${id}",
  toggleFAQsCategoryStatus: "faqs/toggleFAQsCategoryStatus",
  searchFAQsCategories: "faqs/searchFAQsCategories/${query}",

  // // //FAQ's
  addNewFAQs: "faqs/addFAQs",
  updateFAQs: "faqs/updateFAQs",
  getFAQsList: "faqs/getFAQs?page=${page}&pageSize=${pageSize}",
  deleteFAQById: "faqs/deleteFAQ/${id}",
  toggleFAQStatus: "faqs/toggleFAQStatus",
  getFAQsByCategoryId:
    "faqs/getFAQsByCategory?id=${id}&page=${page}&pageSize=${pageSize}",
  restoreFAQ: "faqs/restoreFAQ/${id}",

  // // //Games
  addNewGame: "games/addGame",
  updateGame: "games/updateGame",
  getGamesList: "games/getGames?page=${page}&pageSize=${pageSize}",
  deleteGameByID: "games/deleteGame/${id}",
  toggleGameStatus: "games/toggleGameStatus",
  searchGames:
    "games/searchGames?query=${query}&page=${page}&pageSize=${pageSize}",
  getMiscData: "games/getMiscData",
  getGameById: "games/getGameById/${id}",
  uploadGameImage: "games/uploadGameImage/${id}",
  uploadGameThumbnail: "games/uploadGameThumbnail/${id}",
  addGameApiInfo: "games/addGameApiInfo",
  updateGameApiInfo: "games/updateGameApiInfo",
  uploadGameFile: "uploadGame/upload",
  restoreGame: "games/restoreGame/${id}",

  // // // Permissions
  addNewPermission: "permissions/createNewPermission",
  updatePermission: "permissions/updatePermission",
  permissionsList:
    "permissions/allPermissions?page=${page}&pageSize=${pageSize}",
  togglePermissionStatus: "permissions/toggleStatus",
  deletePermission: "permissions/deletePermission/${id}",
  searchPermission: "permissions/search/${query}",
  systemModulesList: "permissions/systemModulesList",

  // // // Role Permissions
  getRolePermissionsList: "rolePermissions/getRolePermissionsList",
  getRolePermissionsByModules:
    "rolePermissions/getRolePermissionsByModules/${id}",
  addSingleRP: "rolePermissions/addRolePermission",
  removeSingleRP: "rolePermissions/removeRolePermission",
  addBulkRP: "rolePermissions/addBulkRolePermissions",
  removeBulkRP: "rolePermissions/removeBulkRolePermissions",

  // // // User Permissions
  getUserPermissionsList: "userPrmissions/getUserPermissionsList",
  getUserPermissionsByModules:
    "userPrmissions/getUserPermissionsByModules/${id}",
  addSingleUP: "userPrmissions/addUserPermission",
  removeSingleUP: "userPrmissions/removeUserPermission",
  addBulkUP: "userPrmissions/addBulkUserPermissions",
  removeBulkUP: "userPrmissions/removeBulkUserPermissions",
  getUserRole: "userPrmissions/getUserRole/${id}",
  setUserRole: "userPrmissions/setUserRole",

  // // // // Achievement
  addAchievement: "achievements/addAchievement",
  updateAchievement: "achievements/updateAchievement",
  deleteAchievement: "achievements/deleteAchievement/${id}",
  achievementList: "achievements/achievementList",
  paginatedAchievementList:
    "achievements/paginatedAchievementList?page=${page}&pageSize=${pageSize}",
  toggleAchievementStatus: "achievements/toggleAchievementStatus",
  searchAchievement:
    "achievements/searchAchievement?query=${query}&page=${page}&pageSize=${pageSize}",
  restoreAchievemnet: "achievements/restoreAchievemnet/${id}",
  uploadAchievementIcon: "achievements/uploadAchievementIcon/${id}",

  // // // // Badges
  addBadge: "badges/addBadge",
  updateBadge: "badges/updateBadge",
  deleteBadge: "badges/deleteBadge/${id}",
  badgesList: "badges/badgesList",
  paginatedBadgesList:
    "badges/paginatedBadgesList?page=${page}&pageSize=${pageSize}",
  toggleBadgeStatus: "badges/toggleBadgeStatus",
  searchBadges:
    "badges/searchBadges?query=${query}&page=${page}&pageSize=${pageSize}",
  uploadBadgeIcon: "badges/uploadBadgeIcon/${id}",
  restoreBadge: "badges/restoreBadge/${id}",

  // // //Account Feedback
  getPaginatedFeedback:
    "accountFeedback/getPaginatedFeedback?page=${page}&pageSize=${pageSize}",
  searchfeedbacks:
    "accountFeedback/searchfeedbacks?query=${query}&page=${page}&pageSize=${pageSize}",
  getFeedbackCategories: "accountFeedback/getFeedbackCategories",
  respondFeedback: "accountFeedback/respondFeedback",

  // // // Contact Us
  getPaginatedContactUs:
    "contactUs/getPaginatedContactUsList?page=${page}&pageSize=${pageSize}",
  searchContactUs:
    "contactUs/searchContactUs?query=${query}&page=${page}&pageSize=${pageSize}",
  getContactUsCategories: "contactUs/getContactUsCategories",
  respondContactUs: "contactUs/respondContactUs",

  // // // Game Categories
  getGCList: "gameCats/getList",
  getPaginatedGCList:
    "gameCats/getPaginatedList?page=${page}&pageSize=${pageSize}",
  deleteCategory: "gameCats/deleteCategory/${id}",
  toggleCategoryStatus: "gameCats/toggleCategoryStatus",
  searchCategories:
    "gameCats/searchCategories?query=${query}&page=${page}&pageSize=${pageSize}",
  addNewCategory: "gameCats/addNewCategory",
  editCategory: "gameCats/editCategory",
  uploadCatImage: "gameCats//uploadCatImage/${id}",

  // // // Game Sub-Categories
  getSCList: "gameSubCats/getList",
  getSCByCatId: "gameSubCats/getByCategory/${id}",
  getPaginatedList:
    "gameSubCats/getPaginatedList?page=${page}&pageSize=${pageSize}",
  deleteSubCategory: "gameSubCats/deleteSubCategory/${id}",
  toggleSubCatStatus: "gameSubCats/toggleSubCatStatus",
  searchSubCats:
    "gameSubCats/searchSubCats?query=${query}&page=${page}&pageSize=${pageSize}",
  addNewSubCat: "gameSubCats/addNewSubCat",
  editSubCat: "gameSubCats/editSubCat",
  getPaginatedListByCategory:
    "gameSubCats/getPaginatedListByCategory?id=${id}&page=${page}&pageSize=${pageSize}",

  // // // Game Tags
  getGameTags: "gameTags/getList",
  getPaginatedTags:
    "gameTags/getPaginatedList?page=${page}&pageSize=${pageSize}",
  toggleTagStatus: "gameTags/toggleTagStatus",
  deleteTag: "gameTags/deleteTag/${id}",
  searchTags:
    "gameTags/searchTags?query=${query}&page=${page}&pageSize=${pageSize}",
  addNewTag: "gameTags/addNewTag",
  editTag: "gameTags/editTag",

  // // // Custom pages
  pageContentList:
    "customPages/pageContentList?pageCode=${pageCode}&page=${page}&pageSize=${pageSize}",
  togglePageStatus: "customPages/togglePageStatus",
  deletePageById: "customPages/deletePageById/${id}",
  getPagesList: "customPages/getPagesList",
  addPageContent: "customPages/addPageContent",
  updatePage: "customPages/updatePage",
  getBannerData: "customPages/getBannerData",
  uploadBannerImage: "customPages/uploadBannerImage/${id}",
  addNewBanner: "customPages/addNewBanner",
  updatedBanner: "customPages/updatedBanner",
  deleteBanner: "customPages/deleteBanner/${id}",
  getAboutUsPage: "customPages/getAboutUsPage",
  uploadPageMedia: "customPages/uploadPageMedia",
  updateAboutUsPage: "customPages/updateAboutUsPage",
  entitiesforBanner: "customPages/getEntitiesforBanner/${module}",

  // // // GameProviders
  getAllProviders: "gameProvider/getAllProviders",
  paginatedProvidersList:
    "gameProvider/paginatedProvidersList?page=${page}&pageSize=${pageSize}",
  addNewProvider: "gameProvider/addNewProvider",
  updateProvider: "gameProvider/updateProvider",
  toggleProviderStatus: "gameProvider/toggleProviderStatus",
  deleteProvider: "gameProvider/deleteProvider/${id}",
  searchProviders:
    "gameProvider/searchProviders?query=${query}&page=${page}&pageSize=${pageSize}",
  uploadProvidersImage: "gameProvider/uploadProvidersImage/${id}",

  // // // // // // // // Game Bugs
  gameBugsList: "/gameBugs/getGameBugs?page=${page}&pageSize=${pageSize}",
  changeBugStatus: "/gameBugs/changeStatus",
  searchGameBugs:
    "gameBugs/searchGameBugs?page=${page}&pageSize=${pageSize}&query=${query}",

  // // // // // // // // Game Reviews
  paginatedReviews:
    "gameReviews/paginatedReviews?page=${page}&pageSize=${pageSize}",
  searchReviews:
    "gameReviews/searchReviews/${query}?page=${page}&pageSize=${pageSize}",
  searchByStatus:
    "gameReviews/searchByStatus/${status}?page=${page}&pageSize=${pageSize}",
  updateReviewStatus: "gameReviews/updateReviewStatus",

  // // // // // // // // Manage Notifications
  notificationsList:
    "manageNotifications/getPaginatedList?page=${page}&pageSize=${pageSize}",
  usersListForNotifs: "manageNotifications/getUsersList",
  employeesListForNotifs: "manageNotifications/getEmployeesList",
  addNotification: "manageNotifications/addNewNotification",
  deleteNotification: "manageNotifications/deleteNotification/${id}",
  searchNotifications:
    "manageNotifications/searchNotifications?query=${query}&page=${page}&pageSize=${pageSize}",
  searchNotifsByStatus:
    "manageNotifications/searchNotifsByStatus?query=${query}&page=${page}&pageSize=${pageSize}",
  editNotification: "manageNotifications/editNotification",
  updateNotifStatus: "manageNotifications/updateNotifStatus",

  // // // // // // Admin Notifications
  getUnreadCount: "notifications/getUnreadCount",
  notificationList:
    "notifications/notificationList?page=${page}&pageSize=${pageSize}",
  markOneAsRead: "notifications/markOneAsRead/${id}",
  markAllAsRead: "notifications/markAllAsRead",
};
